import { render, staticRenderFns } from "./CuttingSlopeWriteBody.vue?vue&type=template&id=460d7c22&scoped=true"
import script from "./CuttingSlopeWriteBody.vue?vue&type=script&lang=js"
export * from "./CuttingSlopeWriteBody.vue?vue&type=script&lang=js"
import style0 from "./CuttingSlopeWriteBody.vue?vue&type=style&index=0&id=460d7c22&prod&scoped=true&lang=scss"
import style1 from "./CuttingSlopeWriteBody.vue?vue&type=style&index=1&id=460d7c22&prod&scoped=true&lang=scss"
import style2 from "./CuttingSlopeWriteBody.vue?vue&type=style&index=2&id=460d7c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d7c22",
  null
  
)

export default component.exports